import { Button, createMuiTheme, Grid, MuiThemeProvider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Loading from "../Loading";
import { useDispatch } from "react-redux";
import { axiosWithAuth } from "../utils/axiosWithAuth";
import { ERROR, LOADING, LOADING_OFF } from "../store/actions/UserAction";
import User from "./User";
import { useHistory } from "react-router";
import { lightGreen } from '@material-ui/core/colors';
const greenTheme = createMuiTheme({ palette: { primary: lightGreen } })

const Div = styled.div`
    margin-bottom: 3rem;

    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        margin-bottom: 4rem;
    }
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        margin-bottom: 7rem;
    }
`

const StyleTC = styled(TableContainer)`
    max-width: 90%;
    margin: auto;
`

const Executive = (props) => {
    const [roles, setRole] = useState()
    const [members, setMembers] = useState()
    const [admins, setAdmins] = useState()
    const [exec, setExecs] = useState()
    const history = useHistory()
    const dispatch = useDispatch()

    useEffect(()=>{
        setRole(props.userInfo.roles[0].role.roleid)
    },[props.userInfo.roles])

    const newUser = (e) => {
        e.preventDefault()
        history.push('/user/new')
    }

    const delay = (n) => {
        return new Promise((resolve) => {
            setTimeout(resolve,n*1000);
        });
    }

    useEffect(()=>{
        const getEvents = async () => {
            dispatch({type: LOADING, payload: ''})
            dispatch({type: ERROR, payload: ""})
            await delay(.2)
                axiosWithAuth()
                    .get('roles/member')
                    .then(res => {
                        setMembers(res.data.users)
                    })
                    .catch(err => {
                        dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
                    })
                    .finally(() => {
                        dispatch({type: LOADING_OFF, payload: ''})
                    })
        }
        getEvents()
    }, [dispatch, roles])

    useEffect(()=>{
        const getEvents = async () => {
            dispatch({type: LOADING, payload: ''})
            dispatch({type: ERROR, payload: ""})
            await delay(.2)
                axiosWithAuth()
                    .get('roles/role/name/executive')
                    .then(res => {
                        setExecs(res.data.users)
                    })
                    .catch(err => {
                        if (roles && roles === 2) {
                            dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
                        }
                    })
                    .finally(() => {
                        dispatch({type: LOADING_OFF, payload: ''})
                    })
        }
        getEvents()
    }, [dispatch, roles])

    useEffect(()=>{
        const getEvents = async () => {
            dispatch({type: LOADING, payload: ''})
            dispatch({type: ERROR, payload: ""})
            await delay(.2)
                axiosWithAuth()
                    .get('roles/role/name/admin')
                    .then(res => {
                        setAdmins(res.data.users)
                    })
                    .catch(err => {
                        if (roles && roles === 2) {
                            dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
                        }
                    })
                    .finally(() => {
                        dispatch({type: LOADING_OFF, payload: ''})
                    })
        }
        getEvents()
    }, [dispatch, roles])


    return(
        <Div>
            <Grid container direction={"column"} spacing={10} hidden={roles && roles === 2 ? '' : 'true'}>
                <Grid item></Grid> {/*line break*/}
                <Grid item><h4>ADMINS</h4></Grid>
            </Grid>
            {roles && roles === 2?
                 (<StyleTC component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Username</TableCell>
                                <TableCell align="right">First Name</TableCell>
                                <TableCell align="right">Middle Name</TableCell>
                                <TableCell align="right">Last Name</TableCell>
                                <TableCell align="right">Point</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {admins ? admins.map(user => <User info={user}/>) : <p></p>}
                        </TableBody>
                    </Table>
                </StyleTC>) :
                <p></p>
            }
            <br/>
            <Grid container direction={"column"} spacing={10} hidden={roles && roles === 2 ? '' : 'true'}>
                <Grid item></Grid>
                <Grid item><h4>EXECUTIVES</h4></Grid>
            </Grid>
            {roles && roles === 2?
                 (<StyleTC component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Username</TableCell>
                                <TableCell align="right">First Name</TableCell>
                                <TableCell align="right">Middle Name</TableCell>
                                <TableCell align="right">Last Name</TableCell>
                                <TableCell align="right">Point</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {exec ? exec.map(user => <User info={user}/>) : <p></p>}
                        </TableBody>
                    </Table>
                </StyleTC>) :
                <p></p>
            }
            <br/>
            <Grid container direction={"column"} spacing={10}>
                <Grid item></Grid> {/*line break*/}
                <Grid item><h4>MEMBERS</h4></Grid>
            </Grid>

            {!roles ? <Loading/> :
                 (<StyleTC component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Username</TableCell>
                                <TableCell align="right">First Name</TableCell>
                                <TableCell align="right">Middle Name</TableCell>
                                <TableCell align="right">Last Name</TableCell>
                                <TableCell align="right">Point</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {members ? members.map(user => <User info={user}/>) : <p></p>}
                        </TableBody>
                    </Table>
                </StyleTC>)
            }
            <Grid container direction={"column"} spacing={5}>
                <Grid item></Grid> {/*line break*/}
                <Grid item>
                    <MuiThemeProvider theme={greenTheme}>
                        <Button onClick={newUser} variant="contained" color="primary">
                            New User
                        </Button>
                    </MuiThemeProvider>
                </Grid>
            </Grid>
        </Div>
    )
}

export default Executive;